import React from 'react'
import _ from 'underscore'
import { Badge } from '@/components/ui/badge'
import Checkbox from '../checkbox'
import store from '../../state/store'

class TutorAcceptorPosition extends React.Component {

  onToggleAccept = () => {
    if (!this.props.can_toggle) {
      return
    }

    store.emit('ui:tutor_acceptor:toggle_position', this.props.tutoring_job_position.id)
  }

  render() {
    const can_tutor = !_.isEmpty(this.props.tutor_subject)

    return (
      <div className="flex items-center">
        <Checkbox name={this.props.tutoring_job_position.subject_name} classname={"checkbox checkbox-inline-block"} value='selected' checked={this.props.selected} onChange={this.onToggleAccept}/>
        {can_tutor ?
          <Badge variant="success" className="ml-2">Can Tutor</Badge>
          : null
        }
      </div>
    )
  }
}
export default TutorAcceptorPosition
